interface Option {
	id: string;
	value: string;
}

export type ProductAttributeValueType =
	| {type: "color"; value: string}
	| {type: "date"; value: string}
	| {type: "dropdown"; value: Option}
	| {type: "multiselect"; value: Option[]}
	| {type: "number"; value: number}
	| {type: "tags"; value: string[]}
	| {type: "text"; value: string}
	| {type: "textarea"; value: string}
	| {type: "toggle"; value: boolean};

export function getProductAttributeValue(
	attributeValue: Record<string, unknown>,
): ProductAttributeValueType | undefined {
	const keys: ProductAttributeValueType["type"][] = [
		"color",
		"date",
		"dropdown",
		"multiselect",
		"number",
		"tags",
		"text",
		"textarea",
		"toggle",
	];

	for (const key of keys) {
		if (attributeValue[key] !== undefined) {
			// The key we matched on is what decides the value's type
			return {
				type: key,
				value: attributeValue[key],
			} as ProductAttributeValueType;
		}
	}

	return undefined;
}

export function getVoyadoKey(type: string, ...ids: string[]): string {
	return [type, ...ids.map((id) => id.replaceAll("=", ""))].join("-");
}
